<template>
  <div id="app" :style="{'--color': themeColor}">
    <router-view/>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import {colorPrimary} from '@/styles/element-variables.scss'
export default {
  name: 'App',
  inject: {
    themeConfig: {
      default: () => ({
        themeColor: '',
        defaultColor: ''
      })
    }
  },
  data() {
    return {
      themeColor: '',
      colorPrimary
    }
  },
  watch: {
    $route() {
      // 关键作用-进入到具体路由页面更新页面中DOM样式
      if (typeof this.themeConfig.themeColor != 'undefined' && this.themeConfig.themeColor !== this.themeConfig.defaultColor) {
        this.$nextTick(() => {
          if (this.themeConfig.themeColor && this.themeConfig.defaultColor) {
            this.setThemeColor(this.themeConfig.themeColor, this.themeConfig.defaultColor)
          }
        })
      }
    }
  },
  created() {
    // 如果本地存在主题色从本地获取，并提交给root分发到页面进行渲染
    if(Cookies.get('themeColor')) {
      this.themeColor = Cookies.get('themeColor');
      this.$$dispatch('root','root.config',[this.themeColor,true]); // 传递数组-解决初始加载执行setThemeColor两次问题
    } else {
      this.themeColor = this.themeConfig.themeColor;
    }
  },
  methods: {
    async getAgentInfo() {
      
    }
  }
}
</script>

<style lang="scss" scope>
  #app {
    background: #F8F8F8;
    min-height: 100vh;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue